import React, { Component } from 'react';
import { Tabs, Button } from 'antd';
import { connect } from 'react-redux';

import { auth } from '../../services/firebase/firebase';
import { getUserCard } from '../../services/firebase/user';

import Events from "../../services/events";

import { loadUserDataAction, deleteUserStore } from "../../actions/userStoreActions";
import { deleteChatsStore } from "../../actions/chatStoreActions";

import AskForLogin from '../../components/Modules/AskForLogin';

import InfoAndEventsTab from './InfoAndEventsTab';
import SubscriptionsTab from './SubscriptionsTab';
import SavedEventsTab from './SavedEventsTab';
import MyChannelsTab from './MyChannelsTab';
import StatisticTab from './StatisticTab';
import SubscriptionManagementTab from './SubscriptionManagementTab';

const TabPane = Tabs.TabPane;

class MyProfileTabsContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      card: null,
    };

    auth().onAuthStateChanged(user => {
      user && this.props.loadUserDataAction(user.uid)
        .then((user) => {
          user && user.card && getUserCard(user.card)
            .then((card) => {
              this.setState({ card: card });
            })
            .catch((err) => console.error('Error get card:', err));
        })
        .catch((err) => console.error('Error initial profile component', err));

      this.setState({ user })
    });
  };

  async componentDidMount() {
    this.setFilters();
  };

  signOut = async() => {
    await auth().signOut().then(() => {
      this.props.deleteUserStore();
      this.props.deleteChatsStore();
    });
  };

  setFilters() {
    Events.setFilter('events', 'all');
    Events.setSort('time', 'desc')
  };

  render() {
    const {
      user,
      location,
      channels,
      subscriptions,
      events
    } = this.props;

    const { userClaims, uid, savedEvents } = user;
    const isUserReady = user && uid;

    const operations = (
      <div className="tabs-buttons">
        <Button
          className="btn-logout"
          onClick={() => this.signOut()}
        >
          Log Out
        </Button>
      </div>
    );

    let ownChannels = [];

    if (userClaims.userType === "Contributor") {
      channels && channels.map(channel => {

        if (channel.ownerId && channel.ownerId.length > 0) {
          let isArray = Array.isArray(channel.ownerId);

          return isArray && channel.ownerId.map(id => {
            if (id === userClaims.user_id) {
              ownChannels.push(channel)
            }
          })
        }
      })
    } else if (userClaims.userType === "Admin") {
      ownChannels = channels
    }

    let content = (
      <Tabs defaultActiveKey="1" tabBarExtraContent={operations}>
        <TabPane tab="Info & Events" key="1">
          <InfoAndEventsTab
            signOut={this.signOut}
            user={user}
            location={location}
            events={events}
            channels={channels}
            ownChannels={ownChannels}
          />
        </TabPane>
        {/*{*/}
        {/*  (userClaims.userType === "Contributor") && (*/}
        {/*    <TabPane tab="Payments" key="2">*/}
        {/*      <PaymentsTab*/}
        {/*        card={card}*/}
        {/*        events={events}*/}
        {/*        userData={userData}*/}
        {/*        user={user}*/}
        {/*        location={location}*/}
        {/*      />*/}
        {/*    </TabPane>*/}
        {/*  )*/}
        {/*}*/}
        {
          isUserReady && (
            <TabPane disabled tab="Subscriptions" key="3">
              <SubscriptionsTab
                subscriptions={subscriptions}
                user={user}
                channels={channels}
                location={location}
              />
            </TabPane>
          )
        }
        {
          isUserReady && (
            <TabPane tab="Saved events" key="4">
              <SavedEventsTab
                savedEvents={savedEvents}
                events={events}
                location={location}
              />
            </TabPane>
          )
        }
        {
          userClaims.userType && (
            <TabPane tab="My Channels" key="5" disabled={!ownChannels || ownChannels.length === 0}>
              <MyChannelsTab
                ownChannels={ownChannels}
                location={location}
              />
            </TabPane>
          )
        }

        {
          userClaims.userType === "Admin" && (
            <TabPane tab="Statistic" key="6">
              <StatisticTab />
            </TabPane>
          )
        }

        {
          userClaims.userType && (
            <TabPane tab="Subscription Management" key="7" disabled={true}>
              <SubscriptionManagementTab />
            </TabPane>
          )
        }
      </Tabs>
    );
    if (!user || !uid) {
      content = (
        <div className="container">
          <AskForLogin
            page="MyProfile"
          />
        </div>
      )
    }

    return content;
  };
}

export default connect(
  null,
  { loadUserDataAction, deleteUserStore, deleteChatsStore }
)(MyProfileTabsContent);



// WEBPACK FOOTER //
// ./src/pages/MyProfile/MyProfileTabsContent.js